import { render, staticRenderFns } from "./archiv.vue?vue&type=template&id=17f4e5d6&scoped=true&"
import script from "./archiv.vue?vue&type=script&lang=js&"
export * from "./archiv.vue?vue&type=script&lang=js&"
import style0 from "./archiv.vue?vue&type=style&index=0&id=17f4e5d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f4e5d6",
  null
  
)

export default component.exports